export default __webpack_public_path__ + "static/media/error.3c1e405a.svg";